import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

import { DataService } from "../../../core/services/data.service";
import { usuariosModuleName } from "../shared/data.service";

@Component({
    template: require('./usuario-change.component.html'),
    styles: [require('./usuario-change.component.css')]
})
export class UsuarioChangeComponent implements OnInit {
    usuariosModuleName: any = usuariosModuleName;

    private userAdm: string = 'eyJhbGciOiJIUzI1NiJ9.MTgw.0dhL7CSKEEdznJW9AbFAFsBW3kwKBlnWBAXjUkq65is';
    private userVisitante: string = 'eyJhbGciOiJIUzI1NiJ9.MTgx.YlwDOqAiNUqzozngn-VTvhoYJ-9xNJpTQ48AOSZKknc';

    constructor(
        private _dataService: DataService,
        private _router: Router
    ) { }

    ngOnInit() {

    }

    clickVisitor() {
        this._dataService.setToken(this.userVisitante);
        const tenant = this.getCurrentyTenant();

        let router: string = tenant + '/visitante';
        this._router.navigate([router]);
    }

    clickAdm() {
        this._dataService.setToken(this.userAdm);
        const tenant = this.getCurrentyTenant();

        let router: string = tenant + '/';
        this._router.navigate([router]);
    }

    private getCurrentyTenant() {
        const tenants = this._dataService.getTenants();
        const url = this._router.url;
        let x: number, lenX: number;
        for (x = 0, lenX = tenants.length; x < lenX; x++) {
            if (url.indexOf(tenants[x]) !== -1) {
                return tenants[x];
            }
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/usuario-change/usuario-change.component.ts
 **/